/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from "@/api/api.js";

const mutations = {
  updateLanguageList(state, payload) {
    if (payload.append) {
      state.languages.next = payload.data.next;
      state.languages.previous = payload.data.previous;
      state.languages.results = [
        ...state.languages.results,
        ...payload.data.results
      ];
    } else {
      state.languages = payload;
    }
  },
  updateCurrencyList(state, payload) {
    state.currencies = payload;
  },
  updateContactMethodList(state, payload) {
    state.contactMethods = payload;
  },
  updatePaymentConditionList(state, payload) {
    state.paymentConditions = payload;
  },
  updateAxiosConfig(state, payload) {
    if (payload.accessToken) {
      axios.defaults.headers.common["Authorization"] =
        "Token " + payload.accessToken;
    }
    if (payload.language) {
      axios.defaults.headers.common["language"] = payload.language;
    }
    if (payload.currency) {
      axios.defaults.headers.common["currency"] = payload.currency;
    }
  },
  updatedCartItems(state, payload) {
    state.cartItems.push(payload);
  },
  updateAgeGroups(state, payload) {
    state.baseData.ageGroups = payload;
  },
  updateCategories(state, payload) {
    if (payload.append) {
      state.baseData.categories.next = payload.data.next;
      state.baseData.categories.previous = payload.data.previous;
      state.baseData.categories.results = [
        ...state.baseData.categories.results,
        ...payload.data.results
      ];
    } else {
      state.baseData.categories = payload;
    }
  },
  updateCountries(state, payload) {
    if (payload.append) {
      state.baseData.countries.next = payload.data.next;
      state.baseData.countries.previous = payload.data.previous;
      state.baseData.countries.results = [
        ...state.baseData.countries.results,
        ...payload.data.results
      ];
    } else {
      state.baseData.countries = payload;
    }
  },
  updateOccupations(state, payload) {
    state.baseData.occupations = payload;
  },
  updatePeriodicalTypes(state, payload) {
    if (payload.append) {
      state.baseData.periodicalTypes.next = payload.data.next;
      state.baseData.periodicalTypes.previous = payload.data.previous;
      state.baseData.periodicalTypes.results = [
        ...state.baseData.periodicalTypes.results,
        ...payload.data.results
      ];
    } else {
      state.baseData.periodicalTypes = payload;
    }
  },
  updatePaperPublications(state, payload) {
    if (payload.append) {
      state.publicationsPaperFilterList.next = payload.data.next;
      state.publicationsPaperFilterList.previous = payload.data.previous;
      state.publicationsPaperFilterList.results = [
        ...state.publicationsPaperFilterList.results,
        ...payload.data.results
      ];
    } else {
      state.publicationsPaperFilterList = payload;
    }
  },
  updateDigitalPublications(state, payload) {
    if (payload.append) {
      state.publicationsDigitalFilterList.next = payload.data.next;
      state.publicationsDigitalFilterList.previous = payload.data.previous;
      state.publicationsDigitalFilterList.results = [
        ...state.publicationsDigitalFilterList.results,
        ...payload.data.results
      ];
    } else {
      state.publicationsDigitalFilterList = payload;
    }
  },
  updateSecurityQuestions(state, payload) {
    state.baseData.securityQuestions = payload;
  },
  updateDeliveryTypes(state, payload) {
    state.baseData.deliveryTypes = payload;
  },
  updateLatestFilter(state, payload) {
    state.latestFilter = payload;
  },
  updateLatestSearch(state, payload) {
    state.latestSearch = payload;
  },
  setSiteConfig(state, payload) {
    localStorage.setItem("siteConfig", JSON.stringify(payload));
    state.siteConfig = payload;
  },
  updatePreferred(state, payload) {
    state.preferred = payload;
  },

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val;
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val;
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width;
  },

  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex(
      item => item.url == payload.url
    );

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked =
      payload.val;

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(
        state.navbarSearchAndPinList["pages"].data[index]
      );
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex(
        item => item.url == payload.url
      );

      // remove item using index
      state.starredPages.splice(index, 1);
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10);
    state.starredPages = list.concat(starredPagesMore);
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false;
    let lastItemInStarredLimited = state.starredPages[10];
    const starredPagesLimited = state.starredPages.slice(0, 10);
    state.starredPages = starredPagesLimited.concat(list);

    state.starredPages.slice(0, 10).map(i => {
      if (list.indexOf(i) > -1) downToUp = true;
    });

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited);
    }
  },

  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val;
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val;
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {
    if (payload) {
      state.AppActiveUser = payload.data;
      // Store data in localStorage
      localStorage.setItem("userInfo", JSON.stringify(payload));
    } else {
      state.AppActiveUser = payload;
    }
  },
  UPDATE_USER_AVATAR(state, payload) {
    let previous = state.AppActiveUser;
    previous.user.profile.avatar = payload;
    state.AppActiveUser = previous;
  },
  UPDATE_HAS_ROLE(state, payload) {
    let previous = state.AppActiveUser;
    previous.user.has_role = payload;
    state.AppActiveUser = previous;
  }
};

export default mutations;
